import { ONE_MINUTE } from 'constants/charting';
import type { HistoricalDataPeriodInterval, MarketCandlestickVo } from 'models/historical_data';
import type { HistoricalMarketStats } from 'models/stats';

const periodIntervalToSeconds = (periodInterval: HistoricalDataPeriodInterval): number => {
    const parsed = parseInt(periodInterval, 10);
    return parsed === 0 ? 5 : parsed * ONE_MINUTE;
};

/** Server-safe mirror of BinaryMarket's pre-extrapolation candlestick mapping. */
export const mapCandlesticksToStatsHistory = (
    candlesticks: MarketCandlestickVo[],
    periodInterval: HistoricalDataPeriodInterval,
): HistoricalMarketStats[] => {
    let accumulatedVolume = 0;
    let lastValidPrice = 0;
    const intervalSeconds = periodIntervalToSeconds(periodInterval);

    return candlesticks.map((candlestick) => {
        accumulatedVolume += candlestick.volume / 2;
        lastValidPrice =
            candlestick.price.close > 0
                ? candlestick.price.close
                : !!candlestick.price.previous && candlestick.price.previous > 0
                  ? candlestick.price.previous
                  : lastValidPrice;
        return {
            yesAsk: candlestick.yes_ask.close || candlestick.yes_ask.previous || 0,
            yesBid: candlestick.yes_bid.close || candlestick.yes_bid.previous || 0,
            price: lastValidPrice,
            volume: accumulatedVolume,
            openInterest: candlestick.open_interest / 2,
            ts: candlestick.end_period_ts - intervalSeconds,
        };
    });
};

export const emptyStatsHistory = (now: number = Math.round(Date.now() / 1000)): HistoricalMarketStats[] => [
    { yesAsk: 50, yesBid: 50, price: 0, volume: 0, openInterest: 0, ts: now },
];
